var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C1E899"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3a2 2 0 0 1 2-2h21a2 2 0 0 1 2 2v25a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3.26A3.25 3.25 0 0 1 2.5 22c0-1.078.525-2.034 1.333-2.625A3.25 3.25 0 0 1 2.5 16.75c0-1.078.525-2.034 1.333-2.625A3.25 3.25 0 0 1 2.5 11.5c0-1.078.525-2.034 1.333-2.625A3.25 3.25 0 0 1 2.5 6.25A3.25 3.25 0 0 1 4 3.51zm2 17.268V25h21V3H6v.01q.335.025.649.116c.202-.025.545.137.91.424A3.25 3.25 0 0 1 8.99 6H9a.75.75 0 0 1-1.5 0h-.018A1.75 1.75 0 0 0 6 4.518v3.741q.335.026.649.117c.202-.025.545.137.91.424a3.25 3.25 0 0 1 1.432 2.45H9a.75.75 0 0 1-1.5 0h-.018A1.75 1.75 0 0 0 6 9.768v3.741q.335.027.649.117c.202-.024.545.136.91.424A3.25 3.25 0 0 1 8.99 16.5H9a.75.75 0 0 1-1.5 0h-.018A1.75 1.75 0 0 0 6 15.018v3.741q.335.026.649.117c.202-.024.545.136.91.423A3.25 3.25 0 0 1 8.99 21.75H9a.75.75 0 0 1-1.5 0h-.018A1.75 1.75 0 0 0 6 20.268M6 27v1h21v-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.37b169c5c825710fa074878ac695c0cf.svg";
export { ForwardRef as ReactComponent };